export default function maxLength(value: string, length: number, ellipsis = '\u2026'): string {
  const shouldBeTrimmed = value.length + 1 > length;
  return shouldBeTrimmed ? `${value.slice(0, length)}${ellipsis}` : value;
}
